import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/shared/desktop
    */
   getMenuDesktopCount: function(){
    return axios.get( LOGUS_CONFIG.API_URL + '/shared/desktop' );
    },

    /*
        GET     /api/shared/ustawienia
    */
    getMenuSettingsCount: function(){
        return axios.get( LOGUS_CONFIG.API_URL + '/shared/settings' );
    },

     /*
        GET     /api/shared/dictionaries
    */
   getMenuDictionariesCount: function(){
    return axios.get( LOGUS_CONFIG.API_URL + '/shared/dictionaries' );
},

    /*
        GET     /api/shared/lookups
    */
    getLookups: function(){
            return axios.get( LOGUS_CONFIG.API_URL + '/shared/lookups' );
    },

    /*
        GET     /api/shared/lookups/group
    */
   getGroupLookup: function(){
        return axios.get( LOGUS_CONFIG.API_URL + '/shared/lookups/group' );
    },

    /*
        GET     /api/shared/lookups/department
    */
   getDepartmentLookup: function(){
        return axios.get( LOGUS_CONFIG.API_URL + '/shared/lookups/department' );
    },

/*
        GET     /api/shared/lookups/user
    */
   getUserLookup: function(){
        return axios.get( LOGUS_CONFIG.API_URL + '/shared/lookups/user' );
    },

    /*
        GET     /api/shared/lookups/year
    */
   getYearLookup: function(){
    return axios.get( LOGUS_CONFIG.API_URL + '/shared/lookups/year' );
},

/*
        GET     /api/shared/lookups/year
    */
   getRateLookup: function(year_id){
    return axios.get( LOGUS_CONFIG.API_URL + '/shared/lookups/rate/' + year_id );
},

/*
        GET     /api/shared/lookups/course
    */
   getCourseLookup: function(year_id){
    return axios.get( LOGUS_CONFIG.API_URL + '/shared/lookups/course/' + year_id );
},


    // /*
	// 	GET 	/api/schemas/{slug}/edit
	// */
    // getSchemaEdit: function( slug ){
	// 	return axios.get( LOGUS_CONFIG.API_URL + '/schemas/' + slug + '/edit' );
	// },
    
}